export const videoModalActionTypes = {
	TOGGLE_VIDEO_MODAL: 'TOGGLE_VIDEO_MODAL',
} as const;
